import { useUserStore } from '@/shared/stores/user'
import { openDialog, Dialog } from '@/shared/dialogs/dialog'

export const useInfringementReport = () => {
  const userStore = useUserStore()

  const handleGetReport = () => {
    if (!userStore.user?.reportCredits) {
      return openDialog(Dialog.BuyReportCredits)
    }
    openDialog(Dialog.CreateReport)
  }

  return { handleGetReport }
}
